import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "ring-offset-surface-4 focus-visible:ring-ring relative inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 overflow-hidden text-sm font-medium antialiased transition-colors focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:outline-hidden active:translate-y-px disabled:cursor-not-allowed disabled:opacity-50 [&>svg]:pointer-events-none [&>svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-surfarce-4 border-gray-8 text-foreground hover:bg-muted focus-visible:ring-gray-8 border",
        filled:
          "bg-accent-9 text-accent-1 hover:bg-accent-10 focus-visible:ring-accent-9 disabled:hover:bg-accent-9",
        light: "bg-accent-3A text-accent-11 hover:bg-accent-4A focus-visible:ring-accent-9",
        outline:
          "text-foreground hover:border-accent-11 hover:text-accent-11 focus-visible:ring-accent-9 border",
        subtle:
          "hover:bg-muted hover:text-accent-11 focus-visible:ring-accent-9 bg-transparent focus-visible:ring-offset-0",
        text: "text-accent-11 hover:bg-accent-2A hover:text-accent-12 focus-visible:ring-accent-9 bg-transparent focus-visible:ring-offset-0",
        link: "text-accent-11 focus-visible:ring-accent-9 h-auto bg-transparent px-0! py-0! underline-offset-4 hover:underline focus-visible:ring-offset-0",
        dashed:
          "text-foreground hover:border-accent-11 hover:text-accent-11 focus-visible:ring-accent-9 border border-dashed bg-transparent focus-visible:ring-offset-0",
        secondary: "bg-gray-4 text-accent-9 hover:bg-gray-5 focus-visible:ring-gray-4",
        ghost:
          "hover:bg-gray-3 hover:text-gray-11 focus-visible:ring-gray-9 dark:text-muted-foreground bg-transparent focus-visible:ring-offset-0",
      },
      size: {
        xs: "h-6 gap-1 px-2 text-xs *:data-[slot=icon]:size-3",
        sm: "h-7 gap-1.5 px-3 *:data-[slot=icon]:size-4",
        md: "h-8 px-4 *:data-[slot=icon]:size-4",
        lg: "h-9 px-5 text-base *:data-[slot=icon]:size-5",
      },
      radius: {
        none: "rounded-none",
        sm: "rounded-sm",
        md: "rounded",
        lg: "rounded-lg",
        full: "rounded-full",
      },
      shape: {
        default: "",
        square: "",
        circle: "rounded-full!",
        round: "rounded-full!",
      },
      block: {
        true: "w-full",
      },
    },
    compoundVariants: [
      { shape: "square", size: "xs", class: "h-6 w-6 gap-0! px-0! *:data-[slot=icon]:size-3" },
      { shape: "square", size: "sm", class: "h-7 w-7 gap-0! px-0! *:data-[slot=icon]:size-4" },
      { shape: "square", size: "md", class: "h-8 w-8 gap-0! px-0! *:data-[slot=icon]:size-5" },
      { shape: "square", size: "lg", class: "h-9 w-9 gap-0! px-0! *:data-[slot=icon]:size-5" },
      { shape: "circle", size: "xs", class: "h-6 w-6 gap-0! px-0! *:data-[slot=icon]:size-3" },
      { shape: "circle", size: "sm", class: "h-7 w-7 gap-0! px-0! *:data-[slot=icon]:size-4" },
      { shape: "circle", size: "md", class: "h-8 w-8 gap-0! px-0! *:data-[slot=icon]:size-5" },
      { shape: "circle", size: "lg", class: "h-9 w-9 gap-0! px-0! *:data-[slot=icon]:size-5" },
    ],
    defaultVariants: {
      variant: "filled",
      size: "md",
      shape: "default",
    },
  }
);

export type ButtonVariants = VariantProps<typeof buttonVariants>;
